import React, { Fragment, useState } from 'react';
import { Button, Dialog, DialogContent, DialogTitle, DialogActions } from '@material-ui/core';
import { Field, Formik } from 'formik';
import * as Yup from 'yup';

import { GQLParty } from '@jewelutions/core-crm-server-api-client-domain';
import { ErrorComponent, JwlField, LoadingSpinner } from '../../../../components';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';

interface IProps {
  party: GQLParty;
  onClose: (success: boolean) => void;
}

export const CreatePlatformSaleCatalogDialog: React.FC<IProps> = ({ party, onClose }: IProps) => {
  const [errorComponentState, setErrorComponentState] = useState(false);
  const [fontToPersist, setFontToPersist] = useState(null as any);
  const initialValues = {
    name: '',
    description: ''
  };

  const [createFont, { error, loading }] = GQLOperationBuilder.font.createFont();

  const onSubmit = (props: any) => {
    const input: any = {
      ownerPartyId: party.id,
      name: props.name,
      description: props.description
    };

    const mutationVariables = { input: input };

    setFontToPersist(props);
    createFont({ variables: mutationVariables }).then(_ => {
      onClose(true);
    });
  };

  if (error && !errorComponentState)
    return (
      <Dialog open maxWidth="md" aria-labelledby="create-platform-sale-catalog">
        <ErrorComponent
          margins="0"
          close={setErrorComponentState}
          callback={() => onSubmit(fontToPersist)}
          details={error?.stack}
          message={error?.message}
        />
      </Dialog>
    );

  if (loading) return <LoadingSpinner />;

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required')
  });

  return (
    <Dialog open aria-labelledby="create-platform-sale-catalog">
      <Fragment>
        <DialogTitle>Create Platform Sale Catalog</DialogTitle>
        <DialogContent>
          <Formik
            initialValues={{ ...initialValues }}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ values, handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Field name="name" component={JwlField} label="Name" />
                <Field name="name" component={JwlField} label="Description" />

                <DialogActions>
                  <Button color="primary" onClick={() => onClose(false)}>
                    Close
                  </Button>
                  <Button type="submit" color="primary" variant="contained">
                    Save
                  </Button>
                </DialogActions>
              </form>
            )}
          </Formik>
        </DialogContent>
      </Fragment>
    </Dialog>
  );
};

export default CreatePlatformSaleCatalogDialog;
